var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2143_827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2269 47.2705C36.9319 47.2705 47.2313 36.9711 47.2313 24.2661C47.2313 11.5611 36.9319 1.26172 24.2269 1.26172C11.5219 1.26172 1.22247 11.5611 1.22247 24.2661C1.22247 36.9711 11.5219 47.2705 24.2269 47.2705Z",
    fill: "#FF6900"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2143_827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0952 21.8749L18.6017 22.8738C18.4297 23.222 18.0078 23.3648 17.6599 23.1928C17.3117 23.0208 17.1689 22.5991 17.3409 22.251L20.1197 16.6262C20.3759 16.1076 21.1166 16.1038 21.3777 16.6206L23.2357 20.2989C24.6891 19.2124 26.4624 18.5315 28.3866 18.4266C27.7571 14.7817 24.5725 12.0002 20.75 12.0002C16.4769 12.0002 13.0003 15.4769 13.0003 19.7499C13.0003 21.6684 13.7151 23.5138 14.9859 24.929L13.2759 26.2386C12.7428 26.6473 13.0344 27.5 13.7034 27.5H19.4216C19.5123 25.3696 20.3085 23.4185 21.5817 21.875H19.0952V21.8749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7899 20.4687H21.7462L20.7571 18.5107L19.7899 20.4687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7241 34.7382L34.9023 33.343C36.244 31.8621 36.9997 29.924 36.9997 27.9092C36.9997 23.4482 33.3704 19.8188 28.9094 19.8188C24.4484 19.8188 20.819 23.4482 20.819 27.9092C20.819 32.4335 24.5012 35.9995 28.8889 35.9995H36.2965C36.967 35.9995 37.2562 35.1458 36.7241 34.7382ZM31.7124 30.0185C32.1007 30.0185 32.4155 30.3333 32.4155 30.7216C32.4155 31.1099 32.1007 31.4247 31.7124 31.4247C31.5112 31.3997 30.2725 31.5846 28.9047 30.7122C27.5497 31.5765 26.2835 31.4015 26.097 31.4247C25.7087 31.4247 25.3939 31.1099 25.3939 30.7216C25.3939 30.3333 25.7087 30.0185 26.097 30.0185C26.3101 30.0009 26.9766 30.1062 27.7974 29.7199C27.2316 29.0172 26.8697 28.1439 26.8023 27.1904H26.097C25.7087 27.1904 25.3939 26.8756 25.3939 26.4873C25.3939 26.099 25.7087 25.7842 26.097 25.7842H28.2015V25.0968C28.2015 24.7085 28.5164 24.3937 28.9047 24.3937C29.293 24.3937 29.6078 24.7085 29.6078 25.0968V25.7842H31.7218C32.1101 25.7842 32.4249 26.099 32.4249 26.4873C32.4249 26.8756 32.1101 27.1904 31.7218 27.1904H31.007C30.9397 28.1439 30.5778 29.0172 30.012 29.7199C30.8316 30.1056 31.4989 30.0008 31.7124 30.0185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9047 28.8537C29.2825 28.3899 29.5315 27.8172 29.5959 27.1904H28.2135C28.2779 27.8172 28.5269 28.3899 28.9047 28.8537Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2143_827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.169922)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2143_827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(13 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.069ce908dddd56d330bd7ebff9325953.svg";
export { ForwardRef as ReactComponent };